import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, Link, json } from "react-router-dom";
import "./CreateUser.scss";
import { useForm, Controller } from "react-hook-form";
import masterApi from "../../services/masterApi";
import Select from "react-select";
import axios from "axios"; // Optional: Use axios instead of fetch
import Multiselect from "multiselect-react-dropdown";
import CameraIcon from "../../assets/icons/CameraIcon";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../../context/AuthContext";
import { UserRolesEnum, UserRolesEnumLabels ,RecordStatusEnum} from "../../enum/enums";
import Loader from "../../components/loader/Loader";


const CreateUser = ({ existingData, close }) => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const USER_SUCCESS_MESSAGE = process.env.REACT_APP_USER_SUCCESS_MESSAGE
  const UPDATE_SUCCESS_MESSAGE = process.env.REACT_APP_UPDATE_SUCCESS_MESSAGE
  const [recordStatus, setRecordStatus] = useState(existingData?.recordStatus || RecordStatusEnum.ACTIVE); 
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: existingData || [], // set default values to existing data
  });
  const [error, setError] = useState(null);
  const [viewLoader, setViewLoader] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageName, setImageName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [expertiseList, setExpertiseList] = useState([]); // State to hold the fetched data
  const [isEditMode, setIsEditMode] = useState(existingData);
  const [response, setResponse] = useState(null);
  const { user } = useContext(AuthContext);
  const [ isExpertiseRequired,setExpertiseRequired ] = useState(true);
  const [rolesEnum, setRolesEnum] = useState({
    ADMIN: "Admin",
    SUPERVISORS: "Supervisor",
    TECHNICIAN: "Technician",
  });
  const [role, setRole] = useState(existingData?.userRole || UserRolesEnum.TECHINICIAN);
  const [createItemForm, setCreateItemForm] = useState({
    Files: [],
    ImageValue: null,
    Image: null,
  });
  const [roleEnumValues, setUserRolesEnum] = useState([]);


  const notify = () => {
    console.log("inside");
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await masterApi.getAllExpertise();
        const transformedOptions = response?.data?.expertiseList?.filter(item => item.recordStatus === RecordStatusEnum.ACTIVE)?.map(
          (item) => ({
            value: item._id,
            label: item.expertiseName,
          })
        );
        setExpertiseList(transformedOptions);
      } catch (error) {
      } finally {
      }
    };

    if (existingData) {
      setImagePreview(apiBaseUrl + existingData.profileImagePath);
      setValue(
        "expertises",
        existingData?.expertises?.map((item) => ({
          value: item._id, // or any unique identifier
          label: item.expertiseName, // or the property you want to display
        }))
      );
      if(existingData.userRole==UserRolesEnum.TECHINICIAN){
        setExpertiseRequired(true);
      }else{
        setExpertiseRequired(false);
      }
      if (existingData?.recordStatus) {
        setRecordStatus(existingData.recordStatus);
      }
    }

  
    fetchData();
    {
      notify();
    }
  }, []); // Empty dependency array means it runs once on component mount


  useEffect(() => {
    const filteredRoles = Object.keys(UserRolesEnum).filter(
      (role) => UserRolesEnum[role] !== UserRolesEnum.SUPER_ADMIN
    );
    setUserRolesEnum(filteredRoles);
    
    if (user?.userRole === "Admin") {
      roleSettingForAdmin();
    }
    if (user?.userRole === "Supervisor") {
      roleSettingForAdmin();
    }
    const roleSettingForAdmin = () => {
      const updatedRoles = { ...rolesEnum };
      delete updatedRoles["ADMIN"];
      setRolesEnum(updatedRoles);
    };

    const roleSettingForSupervisor = () => {
      const updatedRoles = { ...rolesEnum };
      delete updatedRoles["ADMIN"];
      delete updatedRoles["SUPERVISORS"];
      delete updatedRoles["TECHNICIAN"];
      setRolesEnum(updatedRoles);
    };

    const userRoleValue = user?.userRole;
    if (user?.userRole === "Admin") {
      roleSettingForAdmin();
    }
    if (user?.userRole === "Supervisor") {
      roleSettingForAdmin();
    }
  }, []);

  const onSubmit = async (data) => {
    setViewLoader(true);
    try {
      const formData = new FormData();
      formData.append("firstName", data.firstName);
      formData.append("lastName", data.lastName);
      formData.append("mobile", data.mobile);
      formData.append("username", data.username.trim());
      formData.append("email", data.email);
      formData.append("password", "123456");
      formData.append("image", data.image[0]);
      formData.append("userRole", role);
      formData.append("expertise", JSON.stringify(data.expertises));
      formData.append("userId", existingData?._id);
      formData.append("recordStatus", data.recordStatus ? "Active" : "InActive"); 
      if (!isEditMode) {
        const createResponse = await masterApi.createUser({ formData });
        if (createResponse?.data?.ok) {//sucessfully added user
          setViewLoader(false)
          toast.success(USER_SUCCESS_MESSAGE, {
            autoClose: 1000, // 1 seconds
            onClose: () => {
              close(); // Close after the toast ends
            }
          });
        } else {
          setViewLoader(false)
          toast.error(createResponse?.response?.data?.message, {
            autoClose: 2000, // 1 seconds
          });
        }
      } else {
        const userId = existingData?._id;
        const updateResponse = await masterApi.updateUser({ userId, formData });
        if (updateResponse?.ok) {//sucessfully added user  
          setViewLoader(false)
          toast.success(UPDATE_SUCCESS_MESSAGE, {
            autoClose: 1000,
             onClose: () => {
              close(); // Close after the toast ends
            }
          });
        } else {
          setViewLoader(false)
          toast.error(updateResponse?.response?.data?.message, {
            autoClose: 2000, // 1 seconds
          });
        }
      }
    } catch (error) {
      setViewLoader(false);
      setError("Someting went wrong!");
    }
  };

  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleOptionChange = (event) => {
    setRole(event.target.value); // Update state with the new selected option
    if(event.target.value==UserRolesEnum.TECHINICIAN){
      setExpertiseRequired(true);
    }else{
      setExpertiseRequired(false);
    }
    
  };

  return (
    <form className="" onSubmit={handleSubmit(onSubmit)}>
      <div className="popIn-inner-wrapper">
        <div className="create-user">
          <div className="role">
            {roleEnumValues.map((item, index) => (
              <div className="check1">
                <input
                  className=""
                  type="radio"
                  name={item}
                  id={UserRolesEnumLabels[UserRolesEnum[item]]}
                  value={UserRolesEnum[item]}
                  checked={UserRolesEnum[item] === role}
                  onChange={handleOptionChange}
                ></input>
                <label className="form-check-label1" htmlFor={UserRolesEnumLabels[UserRolesEnum[item]]}>
                  {UserRolesEnumLabels[UserRolesEnum[item]]}
                </label>
              </div>
            ))}
          </div>
          <div className="form">
            <div className="form-group">
              <label>
                First Name<span>*</span>
              </label>
              <input
                {...register("firstName", {
                  required: "First name is required",
                })}
                className={`${
                  errors.firstName ? "form-control required" : "form-control"
                }`}
                type="text"
                placeholder="First Name"
              />
            </div>
            <div className="form-group">
              <label>
                Last Name<span>*</span>
              </label>
              <input
                {...register("lastName", { required: "Last name is required" })}
                className={`${
                  errors.lastName ? "form-control required" : "form-control"
                }`}
                type="text"
                placeholder="Last Name"
              />
            </div>
            <div className="form-group">
              <label>
                User Name<span>*</span>
              </label>
              <input
                {...register("username", {
                  required: "User name is required",                  
                })}
                className={`${
                  errors.username ? "form-control required" : "form-control"
                }`}
                type="text"
                placeholder="User Name"
                disabled={!!existingData?.username} // Disable if `existingData.username` exists
              />
            </div>
            <div className="form-group">
              <label>
                Email
              </label>
              <input
                {...register("email", {
                  validate: (value) => {
                    if (value) {
                      // If email is not empty, apply validation
                      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                        return "Invalid email address";
                      }
                    }
                    // If email is empty, no validation error
                    return true;
                  },
                })}
                className={`${
                  errors.email ? "form-control required" : "form-control"
                }`}
                type="text"
                placeholder="Email"
              />
            </div>
            <div className="form-group">
              <label>
                Phone Number<span>*</span>
              </label>
              <input
                {...register("mobile", {
                  required: "true",
                  pattern: {
                    value: /^\+?\d{5,12}$/,
                    message: "Invalid phone number format",
                  },
                })}
                className={`${
                  errors.mobile ? "form-control required" : "form-control"
                }`}
                type="text"
                placeholder="Phone Number"
              />
            </div>
            {isExpertiseRequired &&(
            <div className="form-group">
              <label>
                Expertise<span>*</span>
              </label>
              <div className="expertise"> 
                <Controller
                  name="expertises"
                  control={control}
                  defaultValue={[]} // Set default value as an empty array
                  rules={{ required: "Please select at least one expertise." }}
                  render={({ field: { onChange, value } }) => (
                    <Multiselect
                      options={expertiseList} // Options to display in the dropdown
                      selectedValues={value} // Preselected value to persist in dropdown
                      onSelect={(selectedList) => onChange(selectedList)} // Function will trigger on select event
                      onRemove={(selectedList) => onChange(selectedList)} // Function will trigger on remove event
                      displayValue="label" // Property name to display in the dropdown options
                      className={errors.expertises ? "select-box-error" : "select-box"}
                      // style={{
                      //   searchBox: {
                      //     border: errors.expertises
                      //       ? "1px solid red"
                      //       : "1px solid #ccc", // Highlight if required and not selected
                      //   },
                      // }}
                    />
                  )}
                />
              </div>
            </div>)}
            <div className="form-group status">
              <label>Status<span>*</span></label>
              <label className="toggle-label">
              <input 
              type="checkbox" 
              {...register("recordStatus")}  // Registering the checkbox
              checked={recordStatus === "Active"}  // Control the checkbox state
              onChange={(e) => {
                const newStatus = e.target.checked ? "Active" : "InActive";  // Toggle between Active and Inactive
                setRecordStatus(newStatus);  // Update local state
                setValue("recordStatus", newStatus);  // Update form value via react-hook-form
              }}
            />
                <div className="back">
                  <div className="toggle"></div>
                  <div className="label on">Active</div>
                  <div className="label off">Inactive</div>
                </div>
              </label>
            </div>
          </div>
          <div className="profile-img">
            <div className="uploadButton">
              {createItemForm.ImageValue && createItemForm.Image === null && (
                <img
                  src={`data:${createItemForm.ImageValue};base64,${createItemForm.ImageValue}`}
                  alt=""
                />
              )}

             
              {imagePreview == null && (
                <div className="uploadTrigger">
                  <div className="icon">
                    <svg width="20" height="18.182" viewBox="0 0 20 18.182">
                      <path
                        id="Path_2519"
                        data-name="Path 2519"
                        d="M2.818,19.182a1.75,1.75,0,0,1-1.284-.534A1.754,1.754,0,0,1,1,17.364V6.455a1.749,1.749,0,0,1,.535-1.284,1.755,1.755,0,0,1,1.284-.535H5.682L7.364,2.818h5.455V4.636H8.159L6.5,6.455H2.818V17.364H17.364V9.182h1.818v8.182a1.822,1.822,0,0,1-1.818,1.818ZM17.364,6.455V4.636H15.545V2.818h1.818V1h1.818V2.818H21V4.636H19.182V6.455ZM10.091,16a4.072,4.072,0,0,0,4.091-4.091,4.074,4.074,0,0,0-4.091-4.091A4.075,4.075,0,0,0,6,11.909,4.074,4.074,0,0,0,10.091,16m0-1.818a2.251,2.251,0,0,1-2.273-2.273,2.251,2.251,0,0,1,2.273-2.273,2.251,2.251,0,0,1,2.273,2.273,2.251,2.251,0,0,1-2.273,2.273"
                        transform="translate(-1 -1)"
                        fill="gray"
                      />
                    </svg>
                  </div>
                </div>
              )}

             
              {imagePreview && (
                <div className="dpDisplay">
                  <img src={imagePreview} alt="Preview" />
                </div>
              )}

              
              <input
                {...register("image", { required: false })}
                type="file"
                accept="image/*"
                onChange={(e) => {
                  onImageChange(e);
                  register("image").onChange(e);
                }}
              />
            </div>
            <label className="form-label">Profile Image</label>
          </div>
        </div>
        {error && (
          <div style={{ color: "red" }} className="alert space-between">
            {error}
          </div>
        )}
        {viewLoader && <Loader />}
        <div className="action-btn">
          <button className="cancel secondary-btn" onClick={close}>
            Cancel
          </button>
          <button className="save primary-btn">
            {isEditMode ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateUser;
